import React from 'react'
import ReactDOM from 'react-dom'

import GlobalStyle from './config/styles'
import Analytics from './config/analytics'

import App from './app'

import reportWebVitals from './reportWebVitals'
import CookieBanner from './components/CookieBanner'
import Head from './config/head'

// Start Goolge Tag Manager
Analytics.start()

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <Head />
    <App />
    <CookieBanner />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
